import type { StockItem } from '@/types/oscar';

/**
 * ⛔ WHAT A SUPPLIER IS ALLOWED TO SEE. Everything on this list is written to
 * be read outside Onsite; everything NOT on it is deliberate:
 *
 *   • UnitCost — Anthony, 13/10/2026: "except price". Telling a supplier what
 *     we last paid is negotiating against ourselves.
 *   • Notes — internal by definition. The whole reason 099 added a second
 *     column rather than reusing it.
 *   • QtyOnHand / MinQty — our stock position is nobody else's business, and a
 *     supplier who knows we have none prices accordingly.
 *
 * ⚠ Asserted by a test. If a field is added to StockItem later it does NOT
 * appear here by default, which is the safe direction for a document that
 * leaves the building.
 */
export function supplierFields(item: StockItem): { label: string; value: string }[] {
  const rows: { label: string; value: string }[] = [];
  const makeModel = [item.Make, item.Model].filter(Boolean).join(' ');
  if (makeModel) rows.push({ label: 'Make and model', value: makeModel });
  if (item.SupplierPartNumber) rows.push({ label: 'Part number', value: item.SupplierPartNumber });
  if (item.Category) rows.push({ label: 'Category', value: item.Category });
  return rows;
}
